/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type NEW_USER_MODERATION = "BAN" | "PREMOD" | "%future added value";
export type EmailDomainConfigContainer_settings = {
    readonly emailDomainModeration: ReadonlyArray<{
        readonly domain: string;
        readonly id: string;
        readonly newUserModeration: NEW_USER_MODERATION;
    }>;
    readonly " $refType": "EmailDomainConfigContainer_settings";
};
export type EmailDomainConfigContainer_settings$data = EmailDomainConfigContainer_settings;
export type EmailDomainConfigContainer_settings$key = {
    readonly " $data"?: EmailDomainConfigContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"EmailDomainConfigContainer_settings">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailDomainConfigContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "EmailDomain",
            "kind": "LinkedField",
            "name": "emailDomainModeration",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "domain",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newUserModeration",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = 'eef7da795ddac77643d64666cbf0f4f6';
export default node;
